import { TagsServiceClient } from '../../common/services/httpClient';

export const getAllTags = async (projectId) => {
  const response = await TagsServiceClient.get(`/projects/${projectId}`);

  return response.data;
};
